export const EventModalClose = 'onClose';
